module.exports = __webpack_public_path__ + "static/img/xyotLogo.142e769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/xyotLogo.png
// module id = yuGK
// module chunks = 44